import { Injectable } from "@angular/core";
import { ISearchHost } from "../interfaces/utils.interface";
import { Subscription } from "rxjs/internal/Subscription";

@Injectable({
  providedIn: "root"
})
export class SearchService {
  private get _defaultSerachTextMessage() {
    return "Ingrese su busqueda aquÃ­";
  }
  private _subscription: Subscription[] = [];
  private _activeComponent: ISearchHost;

  lastSearchText: string;
  get placeHolder(): string {
    return this.filtered ? this.lastSearchText : this._defaultSerachTextMessage;
  }

  filtered = false;
  showSearchBar = false;
  searchText = "";

  get activeComponent() {
    return this._activeComponent;
  }

  set activeComponent(value: ISearchHost) {
    this._activeComponent = value;
    this._susbcriptions();
  }

  executeSearch() {
    if (this.searchText == this.lastSearchText) {
      return;
    }

    this.activeComponent.serviceManager.requestSetting.FilterText = this.searchText;
    this.activeComponent.serviceManager.load();
    this.lastSearchText = this.searchText;
    this.filtered = this.searchText != "";
  }

  private _susbcriptions() {
    this._subscription.push(
      this._activeComponent.onInitialize.subscribe(args => {
        this.showSearchBar = args.showSearchBar;
        this.searchText = "";
        this.lastSearchText = undefined;
        this.filtered = false;
      })
    );

    this._subscription.push(
      this._activeComponent.onDestroy.subscribe(args => {
        this.showSearchBar = args.showSearchBar;

        this._subscription.forEach(subcrip => {
          subcrip.unsubscribe();
        });

        this._subscription = [];
        this._activeComponent = null;
      })
    );
  }
}
